/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EsercenteImportazioneCandidateDTO } from '../model/models';
import { EsercenteImportazioneForm } from '../model/models';
import { EsercenteImportazionePropostaDTO } from '../model/models';
import { EsercenteImportazioneRisultatoDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { RichiestaPraticaEsercenteStatus } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetPropostaImportazioneEsercenteRequestParams {
    idTipoPratica: string;
    daPraticaEsercente: string;
}

export interface ImportaEsercentiDaAltroBandoRequestParams {
    idTipoPratica: string;
    esercenteImportazioneForm: EsercenteImportazioneForm;
}

export interface ListCandidateImportazioneEsercentiRequestParams {
    idTipoPratica: string;
    daTipoPratica: string;
    stato?: Array<RichiestaPraticaEsercenteStatus>;
}


export interface GestioneImportazioneDomandeEsercenteDaAltroBandoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Proposta di clone di una domanda sul form di questo bando.
     * Valori mappati per chiave (system field dall\&#39;anagrafica della domanda, custom per chiave uguale e categoria compatibile), negozi, allegati copiabili (solo file dell\&#39;esercente, mai documenti di sistema), mancanti e campi non mappati, piu\&#39; ragione sociale, P.IVA e tutti i punti vendita dell\&#39;esercente con selezionato. Il bando di origine e\&#39; quello della domanda. Stessi gate dell\&#39;elenco; 404 se la domanda non esiste, e\&#39; su un bando che il chiamante non puo\&#39; consultare, o l\&#39;esercente e\&#39; fuori perimetro. Consensi e dichiarazioni non si copiano.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/importazione/proposta
* @param requestParameters
     */
    getPropostaImportazioneEsercente(requestParameters: GetPropostaImportazioneEsercenteRequestParams, extraHttpRequestParams?: any): Observable<EsercenteImportazionePropostaDTO>;

    /**
     * Importa domande esercente da un altro bando.
     * Body {da_tipo_pratica, pratiche_ids[1..25]}: una transazione per domanda, esito per riga {pratica_origine_id, esito CREATA|SALTATA|ERRORE, motivo (NON_TROVATA, INCOMPLETA, GIA_PRESENTE, NESSUN_NEGOZIO, ESERCENTE_BLOCCATO), errore_codice, pratica_creata_id, codice_pratica, mancanti} e contatori. Le domande create nascono SOTTOMESSE (inserita_da_operatore, clonata_da) e l\&#39;esercente riceve l\&#39;avviso email dopo il commit di ciascuna. Gate generali una volta, prima delle righe: 422 se origine &#x3D; destinazione, lista vuota o oltre 25.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/importazione
* @param requestParameters
     */
    importaEsercentiDaAltroBando(requestParameters: ImportaEsercentiDaAltroBandoRequestParams, extraHttpRequestParams?: any): Observable<EsercenteImportazioneRisultatoDTO>;

    /**
     * Domande del bando di origine importabili su questo bando.
     * Elenco completo (non paginato) delle domande del bando da_tipo_pratica negli stati richiesti (stato ripetibile; default ABILITATA), con il verdetto di importabilita\&#39; sul bando del path: completa, mancanti (chiavi) ed eventuale esclusa_motivo (ESERCENTE_BLOCCATO, GIA_PRESENTE_SU_DESTINAZIONE, NESSUN_NEGOZIO). Gate: checkTipoPratica(path, GESTIONE), checkTipoPratica(origine, CONSULTAZIONE), canale operatore del bando del path (flag spento &#x3D; 404, stato non partecipabile &#x3D; 409). 422 se origine &#x3D; destinazione o piu\&#39; di 1000 domande.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/importazione/candidate
* @param requestParameters
     */
    listCandidateImportazioneEsercenti(requestParameters: ListCandidateImportazioneEsercentiRequestParams, extraHttpRequestParams?: any): Observable<EsercenteImportazioneCandidateDTO>;

}
